import { Modal } from "antd";
import { useTranslation } from "react-i18next";

const DiscardModal = ({ open, onConfirm, onCancel }) => {
  const { t } = useTranslation();

  return (
    <Modal
      title={t("modals.discard.title") || "Discard changes?"}
      open={open}
      onOk={onConfirm}
      onCancel={onCancel}
      okButtonProps={{ danger: true }}
      okText={t("modals.discard.ok") || "Discard"}
      cancelText={t("modals.discard.cancel") || "Cancel"}
      zIndex={2000}
    >
      <p>
        {t("modals.discard.message") ||
          "Are you sure you want to discard all unsaved changes?"}
      </p>
    </Modal>
  );
};

export default DiscardModal;